import React from "react";

const Introduction = props => {
    return (
        <section className="section-introduction">{props.children}</section>
    )
}

export default Introduction;